module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/advanced-search/advanced-search.component.html
// module id = ./src/app/shared/advanced-search/advanced-search.component.html
// module chunks = main